import { Box } from '@mui/material';
import RadioGroupButton from '@acorn-portal/shared/src/components/inputs/radio-button-group';
import { FormikProps } from 'formik';
import { IRenewalMakePaymentForm } from '@acorn-portal/shared/src/pages/renewal/MakePayment';
import { FC } from 'react';
import { ManagedPaymentsValues } from '@acorn-portal/shared/src/pages/paymentManagement/types';

interface IFinancialQuestions {
	formik: FormikProps<IRenewalMakePaymentForm> | FormikProps<ManagedPaymentsValues>;
}

export interface IFinancialQuestionsValues {
	is_account_holder?: 'yes' | 'no';
	is_only_signatory_required?: 'yes' | 'no';
}

const FinancialQuestions: FC<IFinancialQuestions> = ({ formik }) => {
	return (
		<Box>
			<RadioGroupButton
				value={formik.values.is_account_holder}
				name='is_account_holder'
				id='is_account_holder'
				onChange={(value) => {
					formik.setFieldTouched('is_account_holder', true, false);
					formik.setFieldValue('is_account_holder', value);
				}}
				error={formik.touched.is_account_holder && Boolean(formik?.errors?.is_account_holder)}
				helperText={formik?.touched?.is_account_holder && formik?.errors?.is_account_holder}
				label='Are you the account holder?'
			/>

			<RadioGroupButton
				value={formik.values.is_only_signatory_required}
				name='is_only_signatory_required'
				id='is_only_signatory_required'
				onChange={(value) => {
					formik.setFieldTouched('is_only_signatory_required', true, false);
					formik.setFieldValue('is_only_signatory_required', value);
				}}
				error={formik.touched.is_only_signatory_required && Boolean(formik?.errors?.is_only_signatory_required)}
				helperText={formik?.touched.is_only_signatory_required && formik?.errors?.is_only_signatory_required}
				label='Are you the only signatory required to authorise this Direct Debit? '
			/>
		</Box>
	);
};

export default FinancialQuestions;
